import { Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { PHONE_DISPLAY, PHONE_HREF } from "@/components/Header";

const FinalCta = () => (
  <section className="bg-[#FFC300] py-16 md:py-24">
    <div className="container text-center max-w-2xl">
      <h2 className="text-3xl md:text-4xl font-black text-[#1a1a1a] leading-tight mb-3">
        Ready to Upgrade or Maintain Your Property?
      </h2>
      <p className="text-[#1a1a1a]/80 text-base mb-10">
        Send us your photos and details for a fast, clear quote.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link
          to="/get-quote"
          className="bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-md hover:opacity-90 transition-opacity text-center"
        >
          Get Free Quote
        </Link>
        <a
          href={PHONE_HREF}
          className="flex items-center justify-center gap-2 border-2 border-[#1a1a1a] text-[#1a1a1a] px-8 py-4 text-lg font-bold rounded-md hover:bg-[#1a1a1a]/5 transition-colors text-center"
        >
          <Phone className="w-5 h-5" />
          Call Now
        </a>
      </div>
    </div>
  </section>
);

export default FinalCta;
